var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 56,
    viewBox: "0 0 54 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.2885 17.9487H37.1582V36.2938H45.2885V17.9487Z",
    fill: "#BDECFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2885 16.0776H37.1582V17.9487H45.2885V16.0776Z",
    fill: "#25C0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3112 17.9487H8.18091V36.2938H16.3112V17.9487Z",
    fill: "#BDECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3112 16.0776H8.18091V17.9487H16.3112V16.0776Z",
    fill: "#25C0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9045 17.9487H22.7742V36.2938H30.9045V17.9487Z",
    fill: "#BDECFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9045 16.0776H22.7742V17.9487H30.9045V16.0776Z",
    fill: "#25C0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9432 2.35645L2.76074 12.1278V16.0779H26.9432H51.1256V12.1278L26.9432 2.35645Z",
    fill: "#BDECFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9432 3.68701L2.76074 13.3959V15.0384L26.9432 5.35021L51.1256 15.0384V13.3959L26.9432 3.68701Z",
    fill: "#25C0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6266 11.0674L27.2976 1.08818C27.0058 0.963444 26.6722 0.963444 26.3803 1.08818L1.36402 11.0674C1.05132 11.1921 0.884543 11.5456 1.03047 11.8782L1.69757 13.5414C1.82265 13.8533 2.17705 13.9988 2.48976 13.874L26.839 4.16511L51.4801 13.8948C51.7928 14.0196 52.1472 13.874 52.2931 13.5622L52.981 11.899C53.1061 11.5664 52.9393 11.1921 52.6266 11.0674Z",
    fill: "#65D3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8944 36.2939H26.9432H5.99201C5.70016 36.2939 5.47084 36.5226 5.47084 36.8137V41.2836H26.9432H48.4155V36.8137C48.4155 36.5434 48.1862 36.2939 47.8944 36.2939Z",
    fill: "#25C0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2084 41.2837H26.9433H3.67809C3.282 41.2837 2.9693 41.5955 2.9693 41.9906V46.1901C2.9693 46.5852 3.282 46.897 3.67809 46.897H26.9433H50.2084C50.6045 46.897 50.9172 46.5852 50.9172 46.1901V41.9906C50.9172 41.6163 50.6045 41.2837 50.2084 41.2837Z",
    fill: "#25C0FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9432 39.6206H5.47084V41.2838H26.9432H48.4155V39.6206H26.9432Z",
    fill: "#BDECFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7347 14.2065C28.5768 14.2065 30.0702 12.7172 30.0702 10.8801C30.0702 9.04299 28.5768 7.55371 26.7347 7.55371C24.8925 7.55371 23.3992 9.04299 23.3992 10.8801C23.3992 12.7172 24.8925 14.2065 26.7347 14.2065Z",
    fill: "#25C0FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7348 55.0049C33.0096 55.0049 38.0963 49.932 38.0963 43.6743C38.0963 37.4166 33.0096 32.3438 26.7348 32.3438C20.4599 32.3438 15.3732 37.4166 15.3732 43.6743C15.3732 49.932 20.4599 55.0049 26.7348 55.0049Z",
    fill: "#65D3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5861 43.2872C22.8988 43.2872 23.2324 43.4119 23.4617 43.6614L26.7138 46.9046L29.9659 43.6406C30.4454 43.1624 31.2376 43.1624 31.7379 43.6406C32.2174 44.1188 32.2174 44.9088 31.7379 45.4078L27.6102 49.5242C27.1308 50.0024 26.3386 50.0024 25.8382 49.5242L21.7106 45.4078C21.2311 44.9296 21.2311 44.1396 21.7106 43.6406C21.9399 43.3911 22.2734 43.2872 22.5861 43.2872Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7139 37.4657C27.4019 37.4657 27.9647 38.027 27.9647 38.7131L27.9647 48.422C27.9647 49.1081 27.4019 49.6694 26.7139 49.6694C26.026 49.6694 25.4631 49.1081 25.4631 48.422L25.4631 38.7131C25.4631 38.027 26.026 37.4657 26.7139 37.4657Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.1773bc8302ad7662d54d11534340f331.svg";
export { ForwardRef as ReactComponent };